import { createStore, withProps } from '@ngneat/elf';
import { TaskDetails, Tasks } from '@/types';

export interface CurrentTasksStateProps {
  response: {
    tasks: Tasks;
    taskDetails: Partial<TaskDetails>;
  };
  dto: {
    validate: boolean;
    comment: string;
  };
}

export const currentTasksInitialState: CurrentTasksStateProps = {
  response: {
    tasks: { tenantId: '', tasks: [], candidateGroup: '', status: '' },
    taskDetails: {},
  },
  dto: {
    validate: false,
    comment: '',
  },
};

export const currentTasKStateStore = createStore(
  { name: 'current-tasks-state' },
  withProps<CurrentTasksStateProps>({
    ...currentTasksInitialState,
  })
);
